import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedVenue: {
    isOnline: true,
    venueAddressOne: "Cheezious Lahore",
    venueAddressTwo: "Shad Bagh Lahore"
  },
  logoUrl: '',
  orderType: 'storeDelivery',
  paymentMethod: "cash",
  orderData: {},
  userLocationLatlong: '',
  currentLocation: '',
  latLongForDelivery: '',
  errorForDeniedLocation: '',
  customerInfo: {
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
  },

};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setOrderType: (state, action) => {
      state.orderType = action.payload;
    },
    setOrderData: (state, action) => {
      state.orderData = action.payload;
    },
    setPaymentMethod: (state, action) => {
      state.paymentMethod = action.payload;
    },
    setLogoUrl: (state, action) => {
      state.logoUrl = action.payload;
    },
    setSelectedVenue: (state, action) => {
      state.selectedVenue = action.payload;
    },
    setCustomerInfo: (state, action) => {
      state.customerInfo = action.payload;
    },
    setUserLocationLatLong: (state, action) => {
      state.userLocationLatlong = action.payload;
    },
    setCurrentLocation: (state, action) => {
      state.currentLocation = action.payload;
    },
    setLatLongForDelivery: (state, action) => {
      state.latLongForDelivery = action.payload;
    },
    setErrorForDeniedLocation: (state, action) => {
      state.errorForDeniedLocation = action.payload;
    },
  },
});

export const { setSelectedVenue, setOrderData, setPaymentMethod, setLogoUrl, setCustomerInfo, setOrderType, setUserLocationLatLong, setCurrentLocation, setLatLongForDelivery, setErrorForDeniedLocation } = themeSlice.actions;
export default themeSlice.reducer;
